import React, { Fragment } from 'react';
import AdMan from 'components/AdMan';
import GeoEdge from 'components/GeoEdge';
import GoogleTagManager from 'components/GoogleTagManager';
import Parsely from 'components/Parsely';
import Prebid from 'components/Prebid';
import AmazonTam from 'components/AmazonTam';
import FacebookPixel from 'components/FacebookPixel';
import PinterestConversionTag from 'components/PinterestConversionTag';
import PerimeterX from 'components/PerimeterX';
import Sailthru from 'components/Sailthru';
import { HAS_ADS } from 'constants/site';

// Head scripts to be inserted into the document. These are third party scripts
// that are ALWAYS loaded. For lazy scripts, use LazyAsset (see other
// implementations for examples).
export const ThirdPartyHead = () => (
  <Fragment>
    <PerimeterX.Head />
    {HAS_ADS && <Prebid.Head />}
    {HAS_ADS && <AmazonTam.Head />}
    <GoogleTagManager.Head />
    <Parsely.Head />
    <FacebookPixel.Head />
    <PinterestConversionTag.Head />
    <Sailthru.Head />
  </Fragment>
);

// Body scripts to be inserted into the document
export const ThirdPartyBody = () => <Parsely.Body />;

function ThirdParty() {
  return (
    <Fragment>
      {HAS_ADS && <GeoEdge />}
      {HAS_ADS && <AdMan />}
      {HAS_ADS && <Prebid />}
      {HAS_ADS && <AmazonTam />}
      <GoogleTagManager />
      <PerimeterX />
      <Parsely />
      <FacebookPixel />
      <PinterestConversionTag />
      <Sailthru />
    </Fragment>
  );
}

export default ThirdParty;
